import toast from "react-hot-toast";

export function isPercentage(value) {
    // Regular expression to match a percentage value
    const percentageRegex = /^(\d+(\.\d+)?%$)|^100%$/;

    return percentageRegex.test(value);
}
export function toastSuccess(message) {
    toast.success(message);
}

export function toastError(error) {
    toast.error(error.response?.data?.message || error.response?.message || error.message);
}


export const formatCurrency = (input, currency = 'USD') => {
    const value = typeof input === 'string' ? parseFloat(input) : input;

    if (isNaN(value)) {
        return '-';
    }

    const currencySymbols = {
        AED: 'د.إ‎',
        USD: '$',
    };

    const formattedCurrency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    }).format(value);

    if (currencySymbols[currency]) {
        return formattedCurrency.replace(currency, currencySymbols[currency]);
    }

    return formattedCurrency;
};



